import { AppContextActionTypes } from "../constants";

export const setAppContext = (context) => ({
  type: AppContextActionTypes.setAppContext,
  payload: context
})
